import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

export interface MissingFieldsParams {
  fields: Array<string>
  onClose: () => void
}

export const MissingFieldsModal = ({ fields, onClose }: MissingFieldsParams) => {
  return (
    <Modal
      title={i18n.t('ats.job_details.promotion.missing_fields.title')}
      description={i18n.t('ats.job_details.promotion.missing_fields.description')}
      illustration="alert"
      onClose={onClose}
    >
      <Box gap="s16" flexDirection="column">
        <ul>
          {fields.map((field) => (
            <li key={field}>
              <Text.Normal size="200">&bull; {field}</Text.Normal>
            </li>
          ))}
        </ul>
      </Box>
    </Modal>
  )
}
